export default [
  {
    path: "/login",
    component: () => import(/* webpackChunkName: "Login" */ "@/views/authentication/Login.vue"),
    name: "login",
    query: "",
    meta: {
      bypassCacheKeyCheck: true,
      title: "login",
      entityName: "login",
    },
  },
  {
    path: "/forgot-password",
    component: () => import(/* webpackChunkName: "ForgotPassword" */ "@/views/authentication/ForgotPassword.vue"),
    name: "forgot-password",
    meta: {
      bypassCacheKeyCheck: true,
      title: "forgotPassword",
      entityName: "forgot-password",
    },
  },
  {
    path: "/reset-password/:token",
    component: () => import(/* webpackChunkName: "RestPassword" */ "@/views/authentication/RestPassword.vue"),
    name: "reset-password",
    meta: {
      bypassCacheKeyCheck: true,
      title: "resetPassword",
      entityName: "reset-password",
    },
  },

  /** aalabs registration flow is different from the other registration flow so it should be a different route */
  {
    path: "/AAlabs-register",
    component: () => import(/* webpackChunkName: "AALabsRegistration" */ "@/views/authentication/AALabsRegistration.vue"),
    name: "AAlabs-register",
    meta: {
      bypassCacheKeyCheck: true,
      title: "AAlabsRegister",
      entityName: "AAlabs-register",
    },
  },
  {
    path: "/registration",
    component: () => import(/* webpackChunkName: "Registration" */ "@/views/authentication/Registration.vue"),
    name: "registration",
    meta: {
      bypassCacheKeyCheck: true,
      title: "registration",
      entityName: "registration",
    },
  },
  {
    path: "/create-password/:token",
    component: () => import(/* webpackChunkName: "CreatePassword" */ "@/views/authentication/CreatePassword.vue"),
    name: "create-password",
    meta: {
      bypassCacheKeyCheck: true,
      title: "createPassword",
      entityName: "create-password",
    },
  },
  /* to be removed after business confirmation */
  {
    path: "/publisher-register",
    redirect: (to) => ({
      path: "/registration",
      query: {
        ...to.query,
      },
    }),
    name: "publisher-register",
    meta: {
      bypassCacheKeyCheck: true,
    },
  },
  {
    path: "/influencer-register",
    redirect: (to) => ({
      path: "/registration",
      query: {
        ...to.query,
      },
    }),
    name: "influencer-register",
    meta: {
      bypassCacheKeyCheck: true,
    },
  },
  {
    path: "/agency-register",
    redirect: "/registration",
    name: "agency-register",
    meta: {
      bypassCacheKeyCheck: true,
    },
  },
  {
    path: "/register/:token",
    redirect: "/create-password/:token",
    name: "register",
    meta: {
      bypassCacheKeyCheck: true,
    },
  },
];
